"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBookVirtualCare = exports.isBookingDisabled = exports.shouldShowBooking = void 0;
const provider_1 = require("./provider");
const globals_1 = require("./constants/globals");
/**
 * Method to determine if a provider tile should show booking information
 * @param {object} provider An object describing a provider.
 * @param {object} modalDisplay A config field representing logic around the modal area.
 * @return {boolean} Whether to show booking information for this provider.
 */
function shouldShowBooking(provider, modalDisplay) {
    return !!(!modalDisplay.hide_cta || !isBookingDisabled(provider));
}
exports.shouldShowBooking = shouldShowBooking;
/**
 * Method to determine if a provider tile should disable the booking button
 * @param {object} provider An object describing a provider.
 * @return {boolean} Whether to disable the booking button for this provider.
 */
function isBookingDisabled(provider) {
    return (!provider.book_online_url &&
        !provider.request_appointment_url &&
        !provider.virtual_care_url &&
        !(0, provider_1.getProviderContactPhone)(provider));
}
exports.isBookingDisabled = isBookingDisabled;
/**
 * Method to tell if a provider should be considered a virtual care booker.
 * @param {object} provider An object describing a provider.
 * @param {object} modalDisplay A config field representing logic around the modal area.
 * @return {boolean} Whether the provider/config combo signals this as a virtual care booker.
 */
function isBookVirtualCare(provider, modalDisplay) {
    const virtualCareProviderWithURL = provider.provider_type === globals_1.PROVIDER_TYPES.VIRTUAL_CARE &&
        provider.virtual_care_url;
    if (virtualCareProviderWithURL) {
        return true;
    }
    const skipModal = modalDisplay.skip_modal;
    const virtualCareOrg = modalDisplay.virtual_care;
    const providerBookUrl = provider.book_online_url;
    const providerVirtualCareUrl = provider.virtual_care_url;
    const virtualCareEnabled = providerVirtualCareUrl && virtualCareOrg;
    return skipModal && !providerBookUrl && virtualCareEnabled;
}
exports.isBookVirtualCare = isBookVirtualCare;
//# sourceMappingURL=booking.js.map